import { secondaryTextClassName, Panel } from '@monecolier/ui';
import type { AttendanceWeeklySummary } from '@monecolier/api-client';
import { AttendanceWeeklyBarChart } from './AttendanceWeeklyBarChart';

interface AttendanceWeeklySummaryPanelProps {
  summary: AttendanceWeeklySummary;
  titleAs?: 'h2' | 'h3' | 'h4';
}

/**
 * ATT-04 — "Présence — cette semaine" (Accueil admin), referme l'exclusion
 * explicite de UX-44 ("présence hebdomadaire ... domaines produit entièrement
 * absents de ce projet", devenu faux depuis ATT-01/02/05). Consomme `GET
 * /dashboard/attendance-weekly-summary` tel quel — aucun recalcul ici, même
 * discipline que `FinancialOverviewPanel` vis-à-vis de `recoveryRate`.
 *
 * ⚠️ État vide EXPLICITE (`summary.isEmpty`) plutôt qu'un graphique à barres
 * toutes à zéro — un graphique zéro silencieux laisserait croire à une
 * absence généralisée réelle plutôt qu'à une absence de pointage (CA#4 du
 * ticket).
 */
export function AttendanceWeeklySummaryPanel({ summary, titleAs }: AttendanceWeeklySummaryPanelProps) {
  const weeklyPercent = summary.weeklyRate === null ? null : Math.round(summary.weeklyRate * 100);

  return (
    <Panel title="Présence — cette semaine" titleAs={titleAs}>
      {summary.isEmpty ? (
        <p className={secondaryTextClassName} data-testid="attendance-weekly-summary-empty">
          Aucun pointage de présence enregistré pour cette semaine.
        </p>
      ) : (
        <>
          <p data-testid="attendance-weekly-summary-rate">
            <span className="text-3xl font-semibold text-gray-900">{weeklyPercent}%</span>
            <span className={`ml-2 ${secondaryTextClassName}`}>de présence cette semaine, toutes classes confondues.</span>
          </p>
          <div className="mt-3">
            <AttendanceWeeklyBarChart days={summary.days} />
          </div>
        </>
      )}
    </Panel>
  );
}
